/* 🤖 this file was generated by svg-to-ts */
export const IconBigBoldOkKreis: {
    name: 'big-bold-ok-kreis';
    data: string;
} = {
    name: 'big-bold-ok-kreis',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M125.2 47a7.5 7.5 0 0 0-14.46 4 48.47 48.47 0 1 1-29.86-32.48A7.5 7.5 0 0 0 86.1 4.45 63.42 63.42 0 1 0 125.2 47"/><path d="M36.69 66.14a7.51 7.51 0 1 0-9.38 11.72l16.78 13.42a11.6 11.6 0 0 0 7.21 2.52 11 11 0 0 0 1.42-.09 11.6 11.6 0 0 0 7.59-4.29l50.41-59.58a7.49 7.49 0 1 0-11.44-9.68L50.8 77.43z"/></svg>`,
};
